import * as actions from '~/actions/expandableSection';

const defaultState = {};

const expandableSectionState = (state = defaultState, action) => {
  switch (action.type) {
    case actions.EXPAND_SECTION:
      return {
        ...state,
        [action.id]: true,
      };
    case actions.COLLAPSE_SECTION:
      return {
        ...state,
        [action.id]: false,
      };
    default:
      return state;
  }
};

export default expandableSectionState;
